export default {
    layout: {
        zh: '简体中文',
        zhTw: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
        copyAddress: '주소 복사',
        switchWallet: '지갑 전환',
        disconnect: '연결 해제',
        copied: '복사됨',
        failed:'failed',
        success:'success',
    },
    node: {
        progress: '진행 중',
        executionSuccessful: '성공',
        at: '',
        view: '보기',
    },
    menu: {
        home: '홈',
        exchange: '교환',
        mining: '채굴',
        assets: '자산',
        earnings: '수익',
        me: '마이',
        notice: '공지',
    },
    exchange: {
        title: '교환',
        send: '보내기',
        receive: '받기',
        obtain: '획득',
        consume: '소모',
        balance: '잔액',
        max: '최대',
        currentPrice: '현재 가격',
        submit: '교환',
        records: '교환 기록',
        price: '가격',
        success: '성공',
        fail: '실패',
    },
    home: {
        brand: 'OnOx',
        slogan: '글로벌 연결, 미래를 열다',
        sloganDesc: '탈중앙화 · 개방 · 효율',
        yield: '수익률',
        notice: '공지1, ABC 채굴 오픈',
        todayOutput: '오늘 풀 산출',
        networkHashrate: '전체 유효 해시레이트',
        price: '현재 시세',
        burned: '총 소각량',
aboutTitle: '$DOL 디플레이션 전략 엔진',
aboutDesc: '$DOL 토큰의 가치를 지속적으로 상승시키는 6단계 소각 메커니즘',
featureHashrate: '$DOL 소각을 통한 해시레이트 획득',
featureHashrateDesc: '공유 및 팀 해시레이트에서 발생하는 무제한 복리 보너스 혜택',
featureDaily: '일일 수익 정산',
featureDailyDesc: '유효 해시레이트를 기준으로 수익이 계산되며, 투명하고 추적 가능한 기록 제공',
featureSecurity: '단계적 해시레이트 확장',
featureSecurityDesc: '신규 예치를 통해 해시레이트를 획득하는 기준이 시간이 지남에 따라 점진적으로 상승',
        bindTitle: '초대 주소 바인딩',
        bindConfirm: '확인',
        bindPlaceholder: '0x000000000000000000000000000000',
        h11:'파이어불 차터(FireBull Charter)',
        h12:'DolphFi 생태계 최초의 DApp',
        h21:'파이어불 차터(FireBull Charter)',
        h22:'미래를 밝히다',
        h31:'OnOx',
        h32:'불꽃으로 상승 모멘텀을 주도하다',
    },
    mining: {
        title: '버닝 채굴',
        subtitle: '해시레이트를 활성화하고 수익을 공유하세요',
        totalT: '총 해시레이트 (T)',
        shareT: '공유 해시레이트',
        teamT: '팀 해시레이트',
        burnT: '버닝 해시레이트',
        validBurnT: '유효 버닝',
        renew: '갱신',
        amountPlaceholder: '버닝 수량을 입력하세요',
        token: '버닝 토큰',
        rate: '실시간 환율',
        balance: '지갑 잔액',
        submit: '버닝 채굴 참여',
        hint: '실제 ',
        burnLog: '버닝 기록',
        shareLog: '공유',
        renewLog: '갱신 기록',
        success: '성공',
        fail: '실패',
        qty: '수량',
        hashrateT: '해시레이트 (T)',
        renewHashrate: '갱신 해시레이트',
        renewFee: '갱신 비용',
        renewDate: '해시레이트 기간',
        renewConvert: '환산 수량',
        renewNote: '안내',
        renewNoteText: '2026.10.1 전에 갱신하세요. 기한이 지나면 채굴 수익을 받을 수 없습니다.',
        renewConfirm: '갱신 확인',
        ext1:'보상 해시레이트',

        ext2:'채굴 수익',

        ext3:'갱신 금액',
        rechargeTip: '처음 참여하시나요? 먼저 DOL ​​또는 USDT를 충전해 주세요.',
        goRecharge: '충전하러 가기',
        renewdo: '갱신됨',
    },
    earnings: {
        balance: '자산 잔액',
        recharge: '입금',
        withdraw: '출금',
        totalWithdraw: '누적 출금',
        totalIncome: '총 수익',
        mineIncome: '채굴 수익',
        referral: '추천 보상',
        incomeLog: '수익 기록',
        rechargeLog: '입금 기록',
        withdrawLog: '출금 기록',
        qty: '수량',
        success: '성공',
        pending: '이체 대기',
        fail: '실패',
        rechargeQty: '입금 수량',
        withdrawQty: '출금 수량',
        receiveQty: '입금 수량',
        rechargeTitle: '입금',
        withdrawTitle: '출금',
        rechargeMin: '10 미만 불가',
        minAmount: '100 미만 불가',
        toAccount: '입금 예정',
        fee: '수수료',
        rechargeAddress: '입금 주소',
        address: '출금 주소',
        confirmRecharge: '입금 확인',
        confirmWithdraw: '출금 확인',
        l1:'채굴 수익',
l2:'직접 추천 보상',
l3:'간접 추천 보상'
    },
    me: {
        inviteLink: '내 초대 링크',
        upline: '상위 주소',
        inviteCount: '초대 인원',
        teamCount: '팀 인원',
        bigArea: '대구역 해시레이트 (T)',
        smallArea: '소구역 버닝 (T)',
        team: '팀 멤버',
        direct: '직추',
        indirect: '간추',
        umbrella: '산하',
        burnT: '버닝 (T)',
        personT: '개인 (T)',
        teamBurn: '팀 버닝 (T)',
        teamHash: '팀 해시레이트 (T)',
        remark: '메모',
        setRemark: '메모 설정',
        remarkPlaceholder: '메모를 입력하세요',
        confirm: '확인',
    },
    notice: {
        title: '공지 상세',
        headline: '제목 제목 제목 제목',
        date: '2024-12-22',
        body: '안녕하세요.\n\nXXXApp은 2024년 11월 26일 저녁 8시에 정식 오픈합니다.',
    },
};
